








import { Component, Vue } from 'vue-property-decorator'
import { ExStore } from 'vuex'

@Component({
  components: {
    CallUserSelect: () => import('@/components/call/CallUserSelect.vue'),
    Modal: () => import('@/components/common/modals/Modal.vue')
  }
})
export default class CallUserSelectModal extends Vue {
  $store!: ExStore

  get visible() {
    return this.$store.getters['call/userselectModal']
  }

  handleClickClose() {
    this.$emit('change', false)
    this.$store.dispatch('call/displayUserselectModal', false)
  }
}
